console.log("init Proteus treatments -- 1.01")

let activation_param = "pt=freetea";

const add_item_to_cart = (var_id) =>{
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: [
            {
                id: var_id,
                quantity: 1,
                properties: {
                    source: "email signup",
                    _discount: "email signup",
                }
            }
            ]
        })
    }).then(res => res.json()).then(data => {
    console.log('Added to cart:', data);
    }).catch(err => console.error('Error adding to cart:', err));
}

if(window.sessionStorage.getItem("[FGO-01] in-cart treatment") || window.location.href.indexOf(activation_param) > -1){
    window.sessionStorage.setItem("[FGO-01] in-cart treatment", true);

    waitUntil(() => {
        return typeof upcartGetCart != "undefined" && typeof upcartGetCart() == "object";
    }).then(() => {

        let review_cart = () => {

            let cart_data = upcartGetCart();
            waitForElement('#upCart').then(cart => {

                let show_gwp = false;
                for(let i = 0; i < cart_data.items.length; i++){
                    if(cart_data.items.length > 0){
                        show_gwp = true;
                    }
                    if(cart_data.items[i].properties.source == "email signup"){
                        show_gwp = false;
                        break;
                    }
                }

                if(show_gwp){
                    // an item is in the cart AND not the offer
                    // add_item_to_cart(41263519072434);

                    console.log("setting it up")
                
                    let options_html = ``
                    for(let i = 0; i < window.tea_20ct.length; i++){
                        options_html += `
                        <option value="${window.tea_20ct[i].var_id}">${window.tea_20ct[i].flavor}</option>
                        `;
                    }
                    if(cart.shadowRoot.querySelectorAll('.js-offer').length == 0){
                        cart.shadowRoot.querySelector('.upcart-product-item').insertAdjacentHTML("beforebegin", `
                            <style>
                            .js-offer{
                                background: #F4F2E9;
                                margin: 15px 30px;
                                padding: 15px;
                            }
                            .js-offer > div{
                                display: flex;
                            }
                            .js-offer a{
                                display: block;
                                padding: 7px 16px;
                                font-size: 14px;
                                font-weight: 600;
                                border-radius: 4px;
                                margin-left: 1rem;
                                color: #fff;
                                background: #000;
                                cursor: pointer;
                            }
                            </style>
                            <div class="js-offer">
                                <p class="upcart-upsells-title UpcartDesignSettings__cartTextColor styles_title__">
                                    Claim Your Free Tea When You Spend $40:
                                </p>

                                <form id="gwp-form">
                                    <div class="styles_PreviewCarousel__variationProduct__">
                                        <div class="styles_PreviewCarousel__selectWrapper__">
                                            <select class="upcart-upsell-item-variant-selector styles_PreviewCarousel__select__" title="productVariant" name="productVariant">
                                                ${options_html}
                                            </select>
                                            <div class="styles_SelectArrow__">
                                                <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.353516 0.840118L3.96848 4.76997L7.58344 0.840118L0.353516 0.840118Z" fill="#6F6F6F"></path></svg>
                                            </div>
                                        </div>
                                        <div class="styles_PreviewCarousel__inputWrapper__">
                                            <input type="submit" class="upcart-upsells-button styles_PreviewCarousel__button__ UpcartDesignSettings__button" value="Add To Cart">
                                        </div>
                                    </div>
                                </form>

                            </div>
                        `)
                    }
                } else {
                    console.log("tearing it down")
                    if(cart.shadowRoot.querySelectorAll('.js-offer') > 0){
                        cart.shadowRoot.querySelector('.js-offer').remove();
                    }
                }
            }).catch();

        }

        // init
        setTimeout(() => {
            review_cart();
        }, 1500)

        const cart = document.querySelector('#upCart');
        if (cart && cart.shadowRoot) {
            observeSelector('.upcart-product-item', line_item => {
                review_cart();
                console.log();
            }, { document: cart.shadowRoot });

            observeSelector('.js-offer form', gwp_form => {
                let gwp_atc = gwp_form.querySelector('a');
                gwp_form.addEventListener("submit", (e) => {
                    let selected_value = gwp_form.querySelector('select').value;
                    e.preventDefault();
                    add_item_to_cart(selected_value)
                    gwp_form.parentNode.style.opacity = 0.5;
                    setTimeout(() => {
                        gwp_form.parentNode.remove();
                    }, 750)
                });
            }, { document: cart.shadowRoot });

        }

    }).catch();

    // if activated, BLOCK the popups

    const og_form_id_desktop = "RGcQeM";
    const og_form_id_mobile = "S8Dyyn";
    const alt_form_id_desktop = "Sk33dU";
    const alt_form_id_mobile = "TAEnvw";

    const select_topmost_ancestor = (element, selector) => {
        if (!element) {
        return null;
        }
    
        // Check if the current element matches the specified selector
        if (!element.closest(selector)) {
        // If it does not match, return the current element
        return element;
        }
    
        // Otherwise, check its parent element recursively
        return select_topmost_ancestor(element.parentElement, selector);
    };

    observeSelector(`form[data-testid="klaviyo-form-${og_form_id_desktop}"], form[data-testid="klaviyo-form-${og_form_id_mobile}"], form[data-testid="klaviyo-form-${alt_form_id_desktop}"], form[data-testid="klaviyo-form-${alt_form_id_mobile}"]`, kl_form => {
        let popup_container = select_topmost_ancestor(kl_form, '.needsclick[class*="kl-"]')
        popup_container.remove();
        document.body.classList.remove("klaviyo-prevent-body-scrolling");
        setTimeout(() => {
            document.body.classList.remove("klaviyo-prevent-body-scrolling");
        }, 500)
    })

}